import { AxiosResponse } from 'axios';
import { cancelListFileUpload } from 'Services';
import { MutationOptions, useMutation } from '@tanstack/react-query';
import { callAll } from 'Utils';

type HookArgs = {
    mutationOptions?: Omit<MutationOptions<AxiosResponse, unknown, unknown, unknown>, 'mutationKey'>;
};

const useCancelListFileUpload = ({ mutationOptions }: HookArgs) => {
    return useMutation(cancelListFileUpload, {
        onSuccess: callAll(mutationOptions?.onSuccess),
        onError: async (error, variables, context) => {
            mutationOptions?.onError?.(error, variables, context);
        }
    });
};

export default useCancelListFileUpload;
